var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtn),expression:"showBtn"}],ref:"backToTopBtn",attrs:{"color":"primary","fab":"","title":"Regresar hacia arriba","fixed":"","bottom":"","large":"","right":""},on:{"click":_vm.backToTop}},[_c('v-icon',[_vm._v("mdi-arrow-up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }